const TYPES = {
    GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
    GET_DASHBOARD_DATA_COMPLETE: 'GET_DASHBOARD_DATA_COMPLETE',
    GET_DASHBOARD_DATA_FAILED: 'GET_DASHBOARD_DATA_FAILED',
    UPDATE_PAYOUT: 'UPDATE_PAYOUT',
    UPDATE_PAYOUT_COMPLETE: 'UPDATE_PAYOUT_COMPLETE',
    UPDATE_PAYOUT_FAILED: 'UPDATE_PAYOUT_FAILED'
};

export default {
    TYPES,

    getDashboardData: payload => ({
        type: TYPES.GET_DASHBOARD_DATA,
        payload
    }),

    getDashboardDataSuccess: settings => ({
        type: TYPES.GET_DASHBOARD_DATA_COMPLETE,
        payload: settings
    }),

    getDashboardDataFailed: error => ({
        type: TYPES.GET_DASHBOARD_DATA_FAILED,
        payload: {error}
    }),

    updatePayout: payload => ({
        type: TYPES.UPDATE_PAYOUT,
        payload
    }),

    updatePayoutSuccess: payload => ({
        type: TYPES.UPDATE_PAYOUT_COMPLETE,
        payload
    }),

    updatePayoutFailed: error => ({
        type: TYPES.UPDATE_PAYOUT_FAILED,
        payload: {error}
    })
};
